import { motion } from 'framer-motion';
import { Calendar, CreditCard, CheckCircle2, ExternalLink } from 'lucide-react';
import { Button } from '../ui/button';

export const ProgrammeesTab = ({ handleGoToPortal }) => (
  <motion.section
    key="programmees"
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -20 }}
    className="py-20 bg-slate-50"
    data-testid="scheduled-trainings"
  >
    <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
      <div className="bg-white rounded-3xl shadow-xl p-12">
        <div className="w-20 h-20 rounded-full bg-teal-100 text-teal-700 flex items-center justify-center mx-auto mb-6">
          <Calendar className="w-10 h-10" />
        </div>
        <h2 className="text-3xl font-bold text-slate-900 mb-4">
          Nos formations programmées
        </h2>
        <p className="text-lg text-slate-600 mb-8 max-w-2xl mx-auto">
          Consultez notre calendrier de formations avec les dates, tarifs et places disponibles.
          Inscrivez-vous directement en ligne et payez de manière sécurisée.
        </p>

        <div className="grid md:grid-cols-3 gap-6 mb-10">
          <div className="p-4 rounded-xl bg-slate-50">
            <Calendar className="w-8 h-8 text-teal-700 mx-auto mb-2" />
            <h4 className="font-semibold text-slate-900">Sessions planifiées</h4>
            <p className="text-sm text-slate-600">Calendrier des prochaines formations</p>
          </div>
          <div className="p-4 rounded-xl bg-slate-50">
            <CreditCard className="w-8 h-8 text-teal-700 mx-auto mb-2" />
            <h4 className="font-semibold text-slate-900">Paiement en ligne</h4>
            <p className="text-sm text-slate-600">CB, virement, convention entreprise</p>
          </div>
          <div className="p-4 rounded-xl bg-slate-50">
            <CheckCircle2 className="w-8 h-8 text-teal-700 mx-auto mb-2" />
            <h4 className="font-semibold text-slate-900">Inscription immédiate</h4>
            <p className="text-sm text-slate-600">Confirmation instantanée</p>
          </div>
        </div>

        <Button
          onClick={handleGoToPortal}
          className="bg-gold-500 hover:bg-gold-600 text-slate-900 font-semibold rounded-full px-10 py-6 text-lg shadow-lg hover:shadow-xl transition-all"
          data-testid="go-to-portal-btn"
        >
          Accéder aux formations programmées
          <ExternalLink className="ml-3 w-5 h-5" />
        </Button>

        <p className="text-sm text-slate-500 mt-6">
          Vous serez redirigé vers notre plateforme de réservation sécurisée
        </p>
      </div>
    </div>
  </motion.section>
);
